import { Routes, Route } from "react-router-dom";
// Below are the imports for the admin application
import AdminLogin from "../pages/admin/admin-login";
import AdminLayout from "../layouts/admin-layout/admin-layout";
import AdminDashboard from "../pages/admin/admin-dashboard";
import OrganizationsPage from "../pages/admin/admin-organizations";
import ViewOrganizationListingCoachTeamMembersPage from "../pages/common/admin-individual-organization";
import OrganizationPerformancePage from "../pages/common/admin-organization-performance";
import OrganizationDrillsPage from "../pages/common/admin-organization-drills";
import ManageAttendancePage from "../pages/common/admin-manage-attendance";
import ResourcesPage from "../pages/admin/resources";
// End of the above code
import NotFound from "../pages/not-found";
import LeadsManagement from "../pages/admin/leads-management";
import BusinessLogin from "../pages/business-leadership/business-login";
import CoachTeamMemberLogin from "../pages/coach-team-member/coach-team-member-login";
import CoachTeamMemberDashboard from "../pages/coach-team-member/coach-team-member-dashboard";
import CoachTeamMemberCourse from "../pages/coach-team-member/coach-team-member-course";
import CoachTeamMemberProfile from "../pages/coach-team-member/coach-team-member-profile";
import CodePrepCoach from "../pages/coach-team-member/code-prep-coach";
import CourseModule from "../pages/coach-team-member/course-module";
import CoachTeamMemberLayout from "../layouts/coach-team-member-layout/coach-team-member-layout";
import SignupPage from "../pages/signup";
import PreTeamCourseSurvey from "../pages/pre-team-course-survey";
import PreCoachCourseSurvey from "../pages/pre-coach-course-survey";
import PostTeamCourseSurvey from "../pages/post-team-course-survey";
import PostCoachCourseSurvey from "../pages/post-coach-course-survey";
import InPersonTrainingFeedback from "../pages/in-person-training-feedback";
import RxnReadyCourseEvaluation from "../pages/rxn-ready-course-evaluation";
import SubmitDrill from "../pages/submit-drill";


function RescueRnRouter() {
  return (
    <Routes>
      {/* Below are the routes for the admin application */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route element={<AdminLayout type="admin" />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/organizations" element={<OrganizationsPage />} />
        <Route path="/admin/organizations/:id/performance" element={<OrganizationPerformancePage />} />
        <Route path="/admin/organizations/:id/manage-attendance" element={<ManageAttendancePage />} />
        <Route path="/admin/organizations/:id/drills" element={<OrganizationDrillsPage />} />
        <Route path="/admin/organizations/:id" element={<ViewOrganizationListingCoachTeamMembersPage />} />
        <Route path="/admin/resources" element={<ResourcesPage />} />
        <Route path="/admin/leads" element={<LeadsManagement />} />
      </Route>
      {/* End of the above code */}
      {/* Below are the code for the Business Leadership routes */}
      <Route path="/business/login" element={<BusinessLogin />} />
      <Route element={<AdminLayout type="business" />}>
        <Route path="/business/organizations/:id/performance" element={<OrganizationPerformancePage />} />
        <Route path="/business/organizations/:id/drills" element={<OrganizationDrillsPage />} />
        <Route path="/business/organizations/:id" element={<ViewOrganizationListingCoachTeamMembersPage />} />
        <Route path="/business/resources" element={<ResourcesPage />} />
      </Route>
      {/* End of the above code */}
      {/* Below are the code for the Coach and Team Member routes */}
      <Route path="/" element={<CoachTeamMemberLogin />} />
      <Route element={<CoachTeamMemberLayout type="coach-team-member" />}>
        <Route path="/dashboard" element={<CoachTeamMemberDashboard />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/course/:id" element={<CoachTeamMemberCourse />} />
        <Route path="/course/:id/module/:moduleSlug" element={<CourseModule />} />
        <Route path="/profile" element={<CoachTeamMemberProfile />} />
        <Route path="/code-prep-coach" element={<CodePrepCoach />} />
      </Route>
      <Route path="/signup/coach/:organizationId" element={<SignupPage role="coach" />} />
      <Route path="/signup/team-member/:organizationId" element={<SignupPage role="team-member" />} />
      <Route path="/pre-team-course-survey" element={<PreTeamCourseSurvey />} />
      <Route path="/pre-coach-course-survey" element={<PreCoachCourseSurvey />} />
      <Route path="/post-team-course-survey" element={<PostTeamCourseSurvey />} />
      <Route path="/post-coach-course-survey" element={<PostCoachCourseSurvey />} />
      <Route path="/in-person-training-feedback" element={<InPersonTrainingFeedback />} />
      <Route path="/rxn-ready-course-evaluation" element={<RxnReadyCourseEvaluation />} />
      <Route path="/submit-drill" element={<SubmitDrill />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default RescueRnRouter;
